import HitContainer from './hit-container';
import Hit from './Hit';

export default HitContainer;
export {HitContainer, Hit};



// WEBPACK FOOTER //
// ./src/universal/components/Hit/index.js